import { render, staticRenderFns } from "./floatingPrice.vue?vue&type=template&id=11a01ae6&scoped=true"
import script from "./floatingPrice.vue?vue&type=script&lang=js"
export * from "./floatingPrice.vue?vue&type=script&lang=js"
import style0 from "./floatingPrice.vue?vue&type=style&index=0&id=11a01ae6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a01ae6",
  null
  
)

export default component.exports